<template>
  <v-layout row wrap fluid justify-center>
    <v-layout mt-2 mb-1 row wrap fluid justify-center>
      <v-flex hidden-sm-and-down>
        <v-spacer></v-spacer>
      </v-flex>
      <associazione-form :elm-anagrafica.sync="associazioneObj" :image.sync="imageObj" :form-mode.sync="formMode" @reset-elm="resetElm()"></associazione-form>
      <v-btn @click="filtersDialogOpen()" class="btnDefault" small color="secondary darken-3 white--text">
        <span v-if="!filled"> <v-icon small left color="white">search</v-icon>Filtri </span>
        <span v-else>
          <v-icon small left color="white">filter_list</v-icon>
          {{ filled }} filtri attivi
        </span>
      </v-btn>
      <v-btn v-if="filled" @click.stop="azzeraFiltri" class="btnDefault" small color="orange white--text">
        <v-icon small left color="white">remove_circle_outline</v-icon>Azzera Filtri
      </v-btn>
      <v-btn slot="activator" v-if="isAdmin" @click="dialogSagittaOpen()" class="btnDefault" small color="accent white--text" dark>
        <v-icon class="mr-1" small>import_export</v-icon>Esporta SAGITTA
      </v-btn>

      <v-btn
        slot="activator"
        v-if="selected.length && checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIAZIONE)"
        @click="dialogDeleteOpen()"
        class="btnDefault; text-xs-center"
        small
        color="red white--text"
      >
        <v-icon small class="mr-1">delete</v-icon>Elimina Associazione
      </v-btn>

      <v-btn @click="loadAssociazioni" class="btnDefault" small color="green white--text"> <v-icon small left color="white" ma-0>cached</v-icon>Aggiorna </v-btn>
    </v-layout>
    <v-container fluid>
      <v-layout row wrap justify-center>
        <v-icon class="hidden-sm-and-down mr-3" left>search</v-icon>
        <v-flex :style="!isMobile ? 'px-1' : 'width: 100%; margin: 10px 0px;'">
          <v-autocomplete v-model="filtraSezioni" :items="sezioni" mt2 item-value="id" item-text="Descrizione" box label="Sezione" clearable hide-details></v-autocomplete>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex :style="!isMobile ? 'px-1' : 'width: 100%; margin: 10px 0px;'">
          <v-text-field v-model="filtraTesto" box item-text="Descrizione" label="Cerca" clearable hide-details></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex v-if="isAdmin" :style="!isMobile ? 'px-1 text-xs-right-mt4' : 'px-1; text-xs-center; margin: 10px 0px;'">
          <v-btn-toggle v-model="filtraStato" flat mandatory>
            <v-btn flat value="all" color="grey">Tutte</v-btn>
            <v-btn :value="1" flat color="primary">Attive</v-btn>
            <v-btn :value="0" flat color="red">NON Attive</v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="associazioniFiltrate"
          :search="filtraTesto"
          :pagination.sync="pagination"
          :custom-sort="customSort"
          :hide-headers="isMobile"
          :class="{ mobile: isMobile }"
          :select-all="checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIAZIONE)"
          class="elevation-1 mt-3 noselect"
        >
          <template slot="items" slot-scope="props">
            <tr v-if="!isMobile" :active="props.selected" @click="props.selected = !props.selected">
              <td v-if="checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIAZIONE)" :class="{ 'red lighten-5': !props.item.isAttivo }">
                <v-checkbox v-if="props.item.isAttivo" v-model="props.selected" @click="props.selected = !props.selected" hide-details></v-checkbox>
                <v-icon v-if="!props.item.isAttivo" color="red darken-3">remove_circle</v-icon>
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable font-weight-bold">{{ props.item.Codice }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable font-weight-bold">{{ props.item.Denominazione }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">{{ props.item.Sezione.Descrizione }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">{{ props.item.CodiceFiscale }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">{{ props.item.SitoWeb }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">{{ props.item.Email }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">
                {{
                  (isResponsabile(props.item) && props.item.id == userData.AssociazioneId) || isAdmin || (userData.Role === 'ASSOCIATO' && props.item.id == userData.AssociazioneId)
                    ? props.item.EmailResponsabile
                    : '-'
                }}
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">{{ props.item.Telefono }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">{{ props.item.IndirizzoCorrispondenza.CittaIndirizzo }}</td>

              <td :class="{ 'red lighten-5': !props.item.isAttivo }">
                <v-tooltip v-if="canModifyAssociazione(props.item.id)" top>
                  <v-btn slot="activator" @click="manageAssociati(props.item.id)" small outline icon class="mr-1" color="accent">
                    <v-icon small color="accent">people</v-icon>
                  </v-btn>
                  <span>Gestisci Tesserati</span>
                </v-tooltip>

                <v-tooltip v-if="canModifyAssociazione(props.item.id)" top>
                  <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="mr-1" color="primary">
                    <v-icon small color="primary">edit</v-icon>
                  </v-btn>
                  <span>Modifica Sodalizio</span>
                </v-tooltip>
                <v-tooltip v-if="checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIAZIONE)" top>
                  <v-btn slot="activator" v-if="props.item.isAttivo" @click="eliminaAssociazione(props.item)" small outline icon color="red">
                    <v-icon small color="red">delete</v-icon>
                  </v-btn>
                  <span>Elimina Sodalizio</span>
                </v-tooltip>
                <v-tooltip v-if="!canModifyAssociazione(props.item.id) && checkFunzione(elencoFunzioni.VISUALIZZAZIONE_ASSOCIAZIONE)" top>
                  <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="mr-1" color="purple">
                    <v-icon small color="purple">visibility</v-icon>
                  </v-btn>
                  <span>Visualizza Scheda</span>
                </v-tooltip>
              </td>
            </tr>

            <tr v-else :active="props.selected" @click="props.selected = !props.selected" style="padding-bottom: 35px;">
              <td class="flex-td">
                <ul class="flex-content">
                  <li v-if="checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIAZIONE)" class="flex-item" data-label="Selezione" bold>
                    <v-checkbox v-if="props.item.isAttivo" v-model="props.selected" @click="props.selected = !props.selected" hide-details></v-checkbox>
                  </li>
                  <li class="flex-item" data-label="Codice" bold>{{ props.item.Codice }}</li>
                  <li class="flex-item" data-label="Sodalizio" bold>{{ props.item.Denominazione }}</li>
                  <li class="flex-item" data-label="Regione">{{ props.item.Sezione.Descrizione }}</li>
                  <li class="flex-item" data-label="Codice Fiscale">{{ props.item.CodiceFiscale }}</li>
                  <li class="flex-item" data-label="Sito Web">{{ props.item.SitoWeb }}</li>
                  <li class="flex-item" data-label="Telefono">{{ props.item.Telefono }}</li>
                  <li class="flex-item" data-label="Città">{{ props.item.IndirizzoCorrispondenza.CittaIndirizzo }}</li>
                  <li class="flex-item" data-label="Email">{{ props.item.Email }}</li>
                  <li class="flex-item" data-label="Email Responsabile">
                    {{
                      (isResponsabile(props.item) && props.item.id == userData.AssociazioneId) ||
                      isAdmin ||
                      (userData.Role === 'ASSOCIATO' && props.item.id == userData.AssociazioneId)
                        ? props.item.EmailResponsabile
                        : '-'
                    }}
                  </li>

                  <li class="flex-row" data-label="Azioni">
                    <v-tooltip v-if="canModifyAssociazione(props.item.id)" top>
                      <v-btn slot="activator" @click="manageAssociati(props.item.id)" small outline icon class="mr-1" color="accent">
                        <v-icon small color="accent">people</v-icon>
                      </v-btn>
                      <span>Gestisci Tesserati</span>
                    </v-tooltip>

                    <v-tooltip v-if="canModifyAssociazione(props.item.id)" top>
                      <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="mr-1" color="primary">
                        <v-icon small color="primary">edit</v-icon>
                      </v-btn>
                      <span>Modifica Sodalizio</span>
                    </v-tooltip>
                    <v-tooltip v-if="checkFunzione(elencoFunzioni.CANCELLAZIONE_ASSOCIAZIONE)" top>
                      <v-btn slot="activator" v-if="props.item.isAttivo" @click="eliminaAssociazione(props.item)" small outline icon color="red">
                        <v-icon small color="red">delete</v-icon>
                      </v-btn>
                      <span>Elimina Sodalizio</span>
                    </v-tooltip>
                    <v-tooltip v-if="!canModifyAssociazione(props.item.id) && checkFunzione(elencoFunzioni.VISUALIZZAZIONE_ASSOCIAZIONE)" top>
                      <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="mr-1" color="purple">
                        <v-icon small color="purple">visibility</v-icon>
                      </v-btn>
                      <span>Visualizza Scheda</span>
                    </v-tooltip>
                  </li>
                </ul>
              </td>
            </tr>
          </template>
          <template slot="no-results">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <template slot="no-data">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <!-- PAGINAZIONE IN TABELLA  -->
          <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
        </v-data-table>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialogDelete" max-width="490" persistent>
      <v-card>
        <v-card-title class="display-1 font-weight-bold red white--text">Elimina i sodalizi selezionati</v-card-title>
        <v-card-text class="headline">{{ deletedItem ? 'Verrà eliminato il sodalizio' : 'Verranno eliminati i sodalizi selezionati' }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="resetDeleteItem()" color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="eliminaAssociazioni()" color="red white--text" dark> <v-icon small left>delete</v-icon>Elimina </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSagitta" persistent max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Esportazione Sodalizi</v-card-title>
        <v-card-text class="headline">Verranno esportati i dati nel formato compatibile con SAGITTA</v-card-text>
        <v-card-actions xs-6>
          <v-spacer></v-spacer>
          <v-btn @click="dialogSagitta = false" color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="exportSodaliziSagitta(0)" v-if="isAdmin" class="btnDefault" xs-6 color="accent white--text" dark>
            <v-icon small left class="mr-1">import_export</v-icon>Esporta SAGITTA Parz.
          </v-btn>
          <v-btn @click="exportSodaliziSagitta(1)" v-if="isAdmin" class="btnDefault" xs-6 color="accent white--text" dark>
            <v-icon small left class="mr-1">import_export</v-icon>Esporta SAGITTA Comp.
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="filtersDialog" width="auto">
      <v-card>
        <v-card-title class="title secondary darken-3 white--text" primary-title>Filtri avanzati</v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex md3 class="px-1">
              <v-text-field v-model="filters.denominazione" box label="Denominazione" clearable></v-text-field>
            </v-flex>
            <v-flex md3 class="px-1">
              <v-text-field v-model="filters.codice" box label="Codice" clearable></v-text-field>
            </v-flex>
            <v-flex md3 class="px-1">
              <v-text-field v-model="filters.codiceFiscale" box label="Codice Fiscale" clearable></v-text-field>
            </v-flex>
            <v-flex md3 class="px-1">
              <v-text-field v-model="filters.partitaIva" box label="Partita IVA" clearable></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4 class="px-1">
              <v-text-field v-model="filters.email" box label="Email" clearable></v-text-field>
            </v-flex>
            <v-flex md4 class="px-1">
              <v-text-field v-model="filters.telefono" box label="Telefono" clearable></v-text-field>
            </v-flex>
            <v-flex md4 class="px-1">
              <v-text-field v-model="filters.cellulare" box label="Cellulare" clearable></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!filters.denominazione && !filters.codice && !filters.codiceFiscale && !filters.partitaIva && !filters.email && !filters.telefono && !filters.cellulare"
            @click="cerca"
            color="secondary darken-3 white--text"
            >Applica Filtri</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import AssociazioneForm from './AssociazioneForm';
  import AssociazioneEntity from './AssociazioneEntity';
  import ImageEntity from '../generale/ImageEntity';
  import { mapGetters, mapActions, mapState } from 'vuex';
  import Util from '@/util';
  import Security from '@/security';

  import { bus } from '@/main';

  export default {
    components: {
      AssociazioneForm,
    },
    data() {
      return {
        elencoFunzioni: Security.enFunzione,
        formModes: Util.enFormMode,
        formMode: Util.enFormMode.VISUALIZZAZIONE,
        filtraTesto: null,
        filtraSezioni: '',
        isMobile: false,
        filtraStato: 1,
        ruoli: Security.ruolo,
        dialogSagitta: false,
        dialogDelete: false,
        deletedItem: null,
        selected: [],
        filtersDialog: false,
        filters: { status: 1 },
        filled: 0, // flag per conteggiare i filtri valorizzati
        associazioneObj: new AssociazioneEntity(),
        imageObj: new ImageEntity(),
        headers: [
          { text: 'Codice', sortable: true, value: 'Codice' },
          { text: 'Denominazione', sortable: true, value: 'Denominazione' },
          { text: 'Sezione', sortable: true, value: 'Sezione.Codice' },
          { text: 'Codice Fiscale', sortable: true, value: 'CodiceFiscale' },
          { text: 'Sito Web', sortable: true, value: 'SitoWeb' },
          { text: 'Email', sortable: true, value: 'Email' },
          { text: 'Email Responsabile', sortable: true, value: 'EmailResponsabile' },
          { text: 'Telefono', sortable: true, value: 'Telefono' },
          {
            text: 'Città',
            sortable: true,
            value: 'IndirizzoCorrispondenza.CittaIndirizzo',
          },
          { text: 'Azioni', sortable: false, value: '' },
        ],
        pagination: {
          rowsPerPage: 10,
        },
        editedItem: {},
      };
    },
    computed: {
      ...mapGetters('associazioniModule', ['getAssociazioni', 'getAssociazione', 'getImage']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters('sharedModule', ['getSezioni']),
      ...mapGetters(['userData']),

      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },

      image() {
        return this.getImage;
      },
      associazione() {
        return this.getAssociazione;
      },
      sezioni() {
        return this.getSezioni;
      },
      associazioni() {
        return this.getAssociazioni;
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      isIscritto() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.ASSOCIATO;
        } else {
          return false;
        }
      },
      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },

      associazioniFiltrate() {
        // filtro in tempo reale
        return this.associazioni.filter((i) => {
          if (!this.filtraSezioni && this.filtraStato == 'all') {
            return true;
          } else if (this.filtraStato != 'all' && !this.filtraSezioni) {
            return i.isAttivo == this.filtraStato;
          } else if (this.filtraSezioni != '' && i.Sezione && this.filtraStato == 'all') {
            return i.Sezione.id == this.filtraSezioni;
          } else {
            if (i.Sezione) {
              return i.Sezione.id == this.filtraSezioni && i.isAttivo == this.filtraStato;
            }
          }
          return false;
        });
      },
    },
    watch: {
      associazione() {
        this.associazioneObj = new AssociazioneEntity(this.associazione);
      },
      image() {
        this.imageObj = new ImageEntity(this.image);
      },

      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },

      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.pagination.rowsPerPage = 7;
            this.isMobile = true;
            break;
          case 'md':
            this.pagination.rowsPerPage = 10;
            this.isMobile = false;
            break;
          case 'lg':
            this.pagination.rowsPerPage = 15;
            this.isMobile = false;
            break;
          case 'xl':
            this.pagination.rowsPerPage = 22;
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      bus.$on('associazioneDialog', function (value) {
        if (!value) {
          vm.associazioneObj = new AssociazioneEntity();
          vm.imageObj = new ImageEntity();
        }
      });
      bus.$on('deleteAssociazioneAsync', function (value) {
        if (value) {
          setTimeout(function () {
            vm.refreshList();
          }, 1000);
        }
      });
      bus.$on('deleteAssociazioni', function (value) {
        if (value) {
          setTimeout(function () {
            vm.refreshList();
          }, 1000);
        }
      });
      vm.loadTipologie();
      vm.loadAssociazioni();

      if (vm.isResponsabile()) {
        vm.filtraTesto = vm.userData.userName;
      }

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.pagination.rowsPerPage = 7;
          this.isMobile = true;
          break;
        case 'md':
          this.pagination.rowsPerPage = 10;
          this.isMobile = false;
          break;
        case 'lg':
          this.pagination.rowsPerPage = 15;
          this.isMobile = false;
          break;
        case 'xl':
          this.pagination.rowsPerPage = 22;
          this.isMobile = false;
          break;
      }
    },
    methods: {
      ...mapActions('associazioniModule', [
        'loadAssociazioni',
        'loadAssociazione',
        'loadImage',
        'deleteAssociazione',
        'deleteAssociazioneAsync',
        'deleteAssociazioni',
        'exportAssociazioniXLS',
        'exportSagittaXLS',
        'filterCol',
        'search',
      ]),
      ...mapActions('sharedModule', ['loadTipologie']),

      filtersDialogOpen() {
        const vm = this;
        vm.filtersDialog = true;
      },

      dialogSagittaOpen() {
        const vm = this;
        vm.dialogSagitta = true;
      },

      dialogDeleteOpen() {
        const vm = this;
        vm.dialogDelete = true;
      },

      editItem(item) {
        const vm = this;
        this.loadAssociazione(item.id).then(() => {
          this.loadImage(item.id).then(() => {
            vm.associazioneObj = new AssociazioneEntity(vm.associazione);
            vm.imageObj = new ImageEntity(vm.image);
            if (vm.canModifyAssociazione(item.id)) {
              vm.formMode = vm.checkFormMode(false);
            } else {
              vm.formMode = vm.formModes.VISUALIZZAZIONE;
            }
            setTimeout(() => {
              bus.$emit('associazioneDialog', true);
            }, 500);
          });
        });
      },

      eliminaAssociazione(item) {
        this.deletedItem = item;
        this.dialogDelete = true;
      },
      isResponsabile() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE;
        } else {
          return false;
        }
      },

      eliminaAssociazioni() {
        /* se ho selezionato un solo elemento effettuando la cancellazione dalla lista */
        if (this.deletedItem) {
          /* chiamo il metodo per la cancellazione singola */
          this.deleteAssociazione(this.deletedItem);
          this.deletedItem = null;
        } else {
          /* ho una selezione multipla */
          const associazioniId = [];
          /* mi creo l'array con solo  gli id da cancellare */
          this.selected.forEach((i) => {
            associazioniId.push(i.id);
          });
          if (associazioniId.length > 0) {
            const item = {
              associazioniId: associazioniId,
            };
            /* chiamo il metodo per la cancellazione multipla */
            this.deleteAssociazioni(item);
            this.selected = [];
          }
          this.deletedItem = null;
        }
        /* chiudo la popup  */
        this.dialogDelete = false;
      },

      resetDeleteItem() {
        this.deletedItem = null;
        this.dialogDelete = false;
      },

      refreshList() {
        const vm = this;
        if (this.$route.params.item) {
          vm.loadAssociazioni(this.$route.params.item);
        }
      },

      manageAssociati(idAssociazione) {
        this.$router.push({ name: 'anagrafica/associazione/associati', params: { idAssociazione: idAssociazione } });
      },
      deleteItem(item) {
        this.deleteAssociazioneAsync(item);
        this.deletedItem = item;
        this.dialogDelete = false;
      },
      deleteItems(items) {
        this.deleteAssociazioni(items);
        this.dialogDelete = false;
        this.selected = [];
      },
      resetElm() {
        this.associazioneObj = new AssociazioneEntity();
        this.imageObj = new ImageEntity();
        this.formMode = this.formModes.VISUALIZZAZIONE;
      },
      formatDate(date) {
        if (date) {
          return new Date(date).toLocaleString().split(',')[0];
        }
      },

      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      checkFormMode(insertMode) {
        if (insertMode && Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIAZIONE, this.userData.Role)) {
          return this.formModes.INSERIMENTO;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIAZIONE, this.userData.Role)) {
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIAZIONE_ASSOCIAZIONE, this.userData.Role)) {
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.VISUALIZZAZIONE_ASSOCIAZIONE, this.userData.Role)) {
          return this.formModes.VISUALIZZAZIONE;
        }
      },
      canModifyAssociazione(idAssociazione) {
        let retVal = false;
        if (idAssociazione) {
          if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIAZIONE, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.AssociazioneId) {
            retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIAZIONE_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      exportSodaliziSagitta(p) {
        const vm = this;
        vm.exportSagittaXLS(p);
        vm.dialogSagitta = false;
      },
      customSort(items, index, isDescending) {
        const compare = new Intl.Collator('it').compare;
        if (index === null) return items;

        return items.sort((a, b) => {
          let sortA = a[index];
          let sortB = b[index];

          if (index == 'Sezione.Codice') {
            sortA = a.Sezione.Descrizione;
            sortB = b.Sezione.Descrizione;
          } else if (index == 'IndirizzoCorrispondenza.CittaIndirizzo') {
            sortA = a.IndirizzoCorrispondenza.CittaIndirizzo;
            sortB = b.IndirizzoCorrispondenza.CittaIndirizzo;
          }

          if (isDescending) {
            [sortA, sortB] = [sortB, sortA];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          [sortA, sortB] = [sortA, sortB].map((s) => {
            return (s || '').toString();
          });

          return compare(sortA, sortB);
        });
      },

      cerca() {
        this.filtersDialog = false;
        this.filterCol({ col: 'isAttivo', val: this.filters.status });
        if (this.filters.sezione) {
          this.filterCol({ col: 'sectionId', val: this.filters.sezione });
        }
        if (this.filters.denominazione) {
          this.filterCol({ col: 'Denominazione', val: this.filters.denominazione });
        }
        if (this.filters.codice) {
          this.filterCol({ col: 'Codice', val: this.filters.codice });
        }
        if (this.filters.codiceFiscale) {
          this.filterCol({ col: 'CodiceFiscale', val: this.filters.codiceFiscale });
        }
        if (this.filters.partitaIva) {
          this.filterCol({ col: 'PartitaIVA', val: this.filters.partitaIva });
        }
        if (this.filters.email) {
          this.filterCol({ col: 'Email', val: this.filters.email });
        }
        if (this.filters.telefono) {
          this.filterCol({ col: 'Telefono', val: this.filters.telefono });
        }
        if (this.filters.cellulare) {
          this.filterCol({ col: 'Cellulare', val: this.filters.cellulare });
        }
        this.search(this.filters.cerca);
        this.filled = 0;
        if (this.filters.denominazione) {
          this.filled++;
        }
        if (this.filters.codice) {
          this.filled++;
        }
        if (this.filters.codiceFiscale) {
          this.filled++;
        }
        if (this.filters.partitaIva) {
          this.filled++;
        }
        if (this.filters.email) {
          this.filled++;
        }
        if (this.filters.telefono) {
          this.filled++;
        }
        if (this.filters.cellulare) {
          this.filled++;
        }
      },
      azzeraFiltri() {
        this.filtersDialog = false;
        this.filters = [];
        this.filled = 0;
        this.loadAssociazioni();
      },
    },
  };
</script>

<style scoped>
  .hToolbar {
    height: auto !important;
  }
</style>
